module.exports = __webpack_public_path__ + "static/media/1.0ed733e5.jpg";